/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { RegisterWalletResponse, RegisterWalletVars } from '../openapi-types.gen.js';

export type { RegisterWalletResponse, RegisterWalletVars } from '../openapi-types.gen.js';

export const useRegisterWallet = createMutationHook<RegisterWalletVars, RegisterWalletResponse, unknown>({
  specName: 'useRegisterWallet',
  path: '/v1/wallets/register',
  method: 'POST',
  resolveUrl: (vars: RegisterWalletVars) => `/v1/wallets/register`,
  buildBody: (vars: RegisterWalletVars) => ({ turnkeyWalletId: vars.turnkeyWalletId, turnkeySubOrgId: vars.turnkeySubOrgId, publicKey: vars.publicKey, walletType: vars.walletType, label: vars.label }),
  parseResponse: (raw: unknown): RegisterWalletResponse => raw as RegisterWalletResponse,
  
  
  
});
